import { searchWord } from "../WordBase";

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export interface GreekSuffix {
  type: "suffix";  // "achtervoegsel"
  ground: string;
  dutch: string;
  passport?: string;
}

export const GREEK_SUFFIXES: GreekSuffix[] = [
  {
    type: "suffix",
    ground: "-περ",
    dutch: "precies ..., juist ...",
  },
  {
    type: "suffix",
    ground: "-κις",
    dutch: "(aantal malen)",
  },
  {
    type: "suffix",
    ground: "-κοντα",
    dutch: "(tiental)",
  },
  {
    type: "suffix",
    ground: "-κόσιοι",
    passport: "-κόσιαι, -κόσια",
    dutch: "(honderdtal)",
  },
  {
    type: "suffix",
    ground: "-σις",
    passport: "-σεως, v.",
    dutch: "(duidt een handeling aan)",
  },
  // {
  //   type: "suffix",
  //   ground: "",
  //   dutch: "",
  // },
];

export const searchGreekSuffix = searchWord(GREEK_SUFFIXES, "Greek suffix", "ground");